var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 5H9.99984L8.33317 3.33334H3.33317C2.40817 3.33334 1.67484 4.075 1.67484 5L1.6665 15C1.6665 15.925 2.40817 16.6667 3.33317 16.6667H16.6665C17.5915 16.6667 18.3332 15.925 18.3332 15V6.66667C18.3332 5.74167 17.5915 5 16.6665 5ZM15.8332 11.6667H13.3332V14.1667H11.6665V11.6667H9.1665V10H11.6665V7.5H13.3332V10H15.8332V11.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolder);
export default __webpack_public_path__ + "static/media/NewFolder.5af8a78b.svg";
export { ForwardRef as ReactComponent };